import {
    getClientNextActionField,
    handleClientNextAction
} from "@/services/clientNextAction";

export default {
    async initPayment () {
        return null
    },
    async checkAvailability () {
        return { available: true }
    },
    async handlePayment ({
        config,
        deviceCode,
        authorizationSubscriptionId,
        createPaymentOrder,
        toast,
        hideLoading
    }) {
        try {
            const gatewayId = config?.thawaniGatewayId || 0
            const createRes = await createPaymentOrder('thawani', gatewayId, deviceCode)
            const internalId = getClientNextActionField(createRes, 'internal_id')
            const rentPaymentId = createRes?.data?.rent_payment_id

            if (!rentPaymentId) {
                throw new Error('Missing rent_payment_id')
            }
            const result = await handleClientNextAction(createRes, {
                beforeRedirect: async () => {
                    try {
                        const store = (await import('@/store')).default
                        if (store && store.dispatch) {
                            store.dispatch('redirect/setRedirect', {
                                flow: 'saveAndBorrow',
                                context: {
                                    rent_payment_id: rentPaymentId,
                                    internal_id: internalId,
                                    subscription_id: authorizationSubscriptionId,
                                }
                            })
                        }
                    } catch (_) {}
                }
            })
            if (!result.handled) {
                throw new Error('Unexpected client_next_action')
            }
            return
        } catch (err) {
            const i18n = (await import('@/main')).default?.i18n
            const fallback = i18n ? i18n.t('tMsg.paymentFailed') : 'Payment failed'
            const message = err?.message || fallback
            toast(message, { persistent: !!err?.message })
            try {
                const router = (await import('@/router')).default
                if (router.currentRoute?.name !== 'payment_select') {
                    router.push({ name: 'payment_select' })
                }
            } catch (_) {}
        } finally {
            hideLoading()
        }
    }
}
